export const EventsContactsActionTypes = {
  API_RESPONSE_SUCCESS: '@@events-contacts/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@events-contacts/API_RESPONSE_ERROR',

  GET_EVENTS_CONTACTS: '@@events-contacts/GET_EVENTS_CONTACTS',
  LIST_EVENTS_CONTACTS: '@@events-contacts/LIST_EVENTS_CONTACTS',
  ADD_EVENTS_CONTACTS: '@@events-contacts/ADD_EVENTS_CONTACTS',
  UPDATE_EVENTS_CONTACTS: '@@events-contacts/UPDATE_EVENTS_CONTACTS',
  DELETE_EVENTS_CONTACTS: '@@events-contacts/DELETE_EVENTS_CONTACTS',

  RESET: '@@events-contacts/RESET'
}
